import styled from 'styled-components';

export const CartPreviewItem = styled.div`
  display: flex;
  justify-content: space-between;
  margin-block-end: 4px;
  padding-block-end: 8px;
`;
